<template>
  <div class="mt-[15px]">
    <div class="flex justify-center items-center">
      <button @click="previousMonth" class="mr-4">
      
        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#525A60" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>


      </button>
      <span class="text-[16px] font-semibold text-[#525A60]">{{ currentMonth.toUpperCase() }} {{ currentYear }}</span>
      <button @click="nextMonth" class="ml-4">
      
        <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 2L8.43043 8.17424C9.18986 8.90341 9.18986 10.0966 8.43043 10.8258L2 17" stroke="#525A60" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>

      
      </button>
    </div>
    <table class="mx-auto mt-2 w-[92%]">
      <thead class="border-b-[1px] border-gray-emb">
        <tr>
          <th class="text-gray-emb text-lg" width="45px">Пн</th>
          <th class="text-gray-emb" width="45px">Вт</th>
          <th class="text-gray-emb" width="45px">Ср</th>
          <th class="text-gray-emb" width="45px">Чт</th>
          <th class="text-gray-emb" width="45px">Пт</th>
          <th class="text-red-atten" width="45px">Сб</th>
          <th class="text-red-atten" width="45px">Нд</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="week in weeks">
          <td 
            v-for="day in week" 
            :key="day.id" 
            class="text-center text-lg py-[4px]" 
            :class="
              {
                'text-red-atten' : day.weekDay == 5 || day.weekDay == 6,
                'text-black-emb' : day.weekDay != 5 && day.weekDay != 6
              }
            "
            height="40px" width="40px"
          >
          <div 
              @click="(checkIfTrainingIsPlanned(day) || checkIfPlannedAndBookedTraining(day)) && !checkIfTrainingIsAttended(day) && !checkIfTrainingIsMissed(day) && emitPlanedTraining(day) || checkIfTrainingIsAttended(day) && emitAttendedTraining(day) || checkIfTrainingIsMissed(day) && emitMissedTraining(day)"
              class="rounded-[8px] text-[20px] w-[40px] h-[40px] align-middle flex justify-center items-center text-center "
              :class="{
                'bg-rose-emb  border-rose-emb' : checkIfTrainingIsMissed(day) && !checkIfTrainingIsAttended(day),
                'border-[2.5px] border-green-emb ' : checkIfPlannedAndBookedTraining(day),
                'bg-green-emb border-green-emb' : checkIfTrainingIsAttended(day),
                'bg-violet-emb border-[2.5px] border-gray-emb ' : checkIfTrainingIsPlanned(day) && !checkIfPlannedAndBookedTraining(day) && !checkIfTrainingIsAttended(day) && !checkIfTrainingIsMissed(day),
                'font-bold text-[21px]' : checkCurrentDay(day),
              }"
            >
              {{ day.monthDay }}
            </div>
            <!-- <div 
              @click="emitPlanedTraining(day)"
              class="rounded-xl bg-opacity-20 h-full align-middle text-center pt-[4px]"
              :class="{
                'bg-[#ABD3EC] border-[2.5px] border-[#DFF726]' : checkIfTrainingIsPlanned(day),
                'bg-[#ABD3EC] border-[2.5px] border-[#990D35]' : checkIfTrainingIsMissed(day) && !checkIfTrainingIsAttended(day),
                'bg-[#ABD3EC] border-[2.5px] border-gray-emb' : checkIfTrainingIsAttended(day),
                'font-bold' : checkCurrentDay(day),
              }"
            >
              {{ day.monthDay }}
            </div> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import { getWeeksInMonth, addingMatchOfTheDayOfTheWeekAndItsNumberInMonth, formatWeeks } from './service/helpers'

  export default {
    data() {
      return {
        currentMonth: '',
        currentYear: '',
        weeks: [],
        currentDate: new Date()
      }
    },

    props: {
      planedTrainings: {
        type: Array,
        default: () => []
      },
      bookedTrainings: {
        type: Array,
        default: () => []
      },
      attendedTrainings: {
        type: Array,
        default: () => []
      },
      missedTrainings: {
        type: Array,
        default: () => []
      },
      completedTrainings: {
        type: Array,
        default: () => []
      }
    },

    created() {
      this.currentDate = new Date()
      this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
      this.currentYear = this.currentDate.getFullYear()
      this.weeks = formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate)))
      console.log('formattedWeeks -------- ', this.weeks)
    },
    methods: {
      previousMonth() {
        this.currentDate = new Date(this.currentYear, this.currentDate.getMonth() - 1)
        this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
        this.currentYear = this.currentDate.getFullYear()
        this.weeks = formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate)))
        console.log('formattedWeeks -------- ', this.weeks)
      },
      nextMonth() {
        this.currentDate = new Date(this.currentYear, this.currentDate.getMonth() + 1)
        this.currentMonth = this.currentDate.toLocaleString('uk-UA', { month: 'long' })
        this.currentYear = this.currentDate.getFullYear()
        this.weeks = formatWeeks(addingMatchOfTheDayOfTheWeekAndItsNumberInMonth(getWeeksInMonth(this.currentDate)))
      },
      checkIfTrainingIsPlanned(day) {
        for (let i = 0; i < this.planedTrainings.length; i++) {
          if (day?.dayDate === undefined) return
          const date = new Date(new Date(day?.dayDate).setDate(day?.dayDate?.getDate() + 1))
          if (this.planedTrainings[i].date.split('T')[0] === date.toISOString().split('T')[0]) {
            return true
          }
        }
        return false
      },
      checkIfTrainingIsAttended(day) {
        for (let i = 0; i < this.attendedTrainings.length; i++) {
          if (day?.dayDate === undefined) return
          const date = new Date(new Date(day?.dayDate).setDate(day?.dayDate?.getDate() + 1))
          if (this.attendedTrainings[i].date.split('T')[0] === date.toISOString().split('T')[0]) {
            return true
          }
        }
        return false
      },
      checkIfTrainingIsMissed(day) {
        for (let i = 0; i < this.missedTrainings.length; i++) {
          if (day?.dayDate === undefined) return
          const date = new Date(new Date(day?.dayDate).setDate(day?.dayDate?.getDate() + 1))
          if (this.missedTrainings[i].date.split('T')[0] === date.toISOString().split('T')[0]) {
            return true
          }
        }
        return false
      },
      checkIfPlannedAndBookedTraining(day) {
        for (let i = 0; i < this.bookedTrainings.length; i++) {
          if (day?.dayDate === undefined) return
          const date = new Date(new Date(day?.dayDate).setDate(day?.dayDate?.getDate() + 1))
          if (this.bookedTrainings[i].date.split('T')[0] === date.toISOString().split('T')[0]) {
            return true
          }
        }
        return false
      },
      checkCurrentDay(day) {
        try {
          //set date day before day.dayDate
          const date = new Date(day.dayDate).setDate(new Date(day.dayDate).getDate() + 1)
          return new Date(date).toISOString().split('T')[0] === new Date().toISOString().split('T')[0]
        } catch (error) {
          return false
        }
      },
      emitPlanedTraining(day) {
        const date = new Date(new Date(day.dayDate).setDate(new Date(day.dayDate).getDate() + 1))
        const emitPlanedTrainings = this.planedTrainings.filter(training => training.date.split('T')[0] === date.toISOString().split('T')[0])
        const emitAttendedTrainings = this.attendedTrainings.filter(training => training.date.split('T')[0] === date.toISOString().split('T')[0])

        if (emitAttendedTrainings.length > 0) {
          return
        }
        //set true if training is booked
        emitPlanedTrainings.map(training => {
          console.log('training -------- ', training)
          console.log('this.bookedTrainings -------- ', this.bookedTrainings)

          const maybeTraining = this.bookedTrainings.find(bookedTraining => bookedTraining.training_id == training.training_id )
          
          if (maybeTraining) {
            training.isBooked = true
          } else {
            training.isBooked = false
          }
          
          return training
        })
        
        this.$emit('planedTraining', emitPlanedTrainings)
      },
      emitAttendedTraining(day) {
        const date = new Date(new Date(day.dayDate).setDate(new Date(day.dayDate).getDate() + 1))
        const emitAttendedTrainings = this.attendedTrainings.filter(training => training.date.split('T')[0] === date.toISOString().split('T')[0])
        this.$emit('attendedTraining', emitAttendedTrainings)
      },
      emitMissedTraining(day) {
        const date = new Date(new Date(day.dayDate).setDate(new Date(day.dayDate).getDate() + 1))
        const emitMissedTrainings = this.missedTrainings.filter(training => training.date.split('T')[0] === date.toISOString().split('T')[0])
        this.$emit('missedTraining', emitMissedTrainings)
      }
    }
  }
</script>
